/**
 * Hooks
 */
// import { useNavigate } from 'react-router-dom';
import useToken from './useToken';
import { DB } from '../utils/indexedDB.js';

export default function useLogout() {

    const { token, setToken } = useToken();
    // const navigate = useNavigate();

    const logout = () => {
        console.log('Loging out...');
        setToken(null); // Remove token

        // Do any cleaning here, like removing session or cookies.
        localStorage.clear();
        DB.clear();

        // Send to app root
        window.location.href = '/pwa/';
    };

    return {
        doLogout: logout,
    }
}
